import React from "react";
import { useT } from "@/i18n";

const LegalPage = ({ ns, testid, sections = 6 }) => {
  const { t } = useT();
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:py-24">
      <p className="text-xs font-semibold uppercase tracking-widest text-[#0F766E]">
        {t(`${ns}.updated`)}
      </p>
      <h1
        data-testid={`${testid}-title`}
        className="mt-3 font-serif text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl"
      >
        {t(`${ns}.title`)}
      </h1>
      <p className="mt-6 text-base leading-relaxed text-slate-700">
        {t(`${ns}.intro`)}
      </p>
      <div className="mt-10 space-y-8">
        {Array.from({ length: sections }, (_, i) => i + 1).map((n) => (
          <section key={n} data-testid={`${testid}-section-${n}`}>
            <h2 className="font-serif text-xl font-semibold text-slate-900">
              {t(`${ns}.s${n}_title`)}
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">
              {t(`${ns}.s${n}_body`)}
            </p>
          </section>
        ))}
      </div>
    </div>
  );
};

export const PrivacyPage = () => (
  <LegalPage ns="privacy" testid="privacy" sections={6} />
);
export const CookiesPage = () => (
  <LegalPage ns="cookies_page" testid="cookies" sections={5} />
);
export const TermsPage = () => (
  <LegalPage ns="terms" testid="terms" sections={6} />
);
